/**
 * AskingPriceStep — Step 5: Stepper for gut price + "Run Diagnosis" CTA.
 */

import { T } from '@/styles/tokens';
import { StepperControl } from './StepperControl';
import { StepNextButton } from './StepNextButton';
import { SectionIcon } from './SectionIcons';

const cardStyle: React.CSSProperties = {
  background: T.white,
  borderRadius: 16,
  border: `1px solid ${T.cream200}`,
  padding: 24,
  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
};

interface AskingPriceStepProps {
  gutPriceCents: number;
  onChangeGutPrice: (cents: number) => void;
  onRunDiagnosis: () => void;
}

export function AskingPriceStep({ gutPriceCents, onChangeGutPrice, onRunDiagnosis }: AskingPriceStepProps) {
  return (
    <div>
      <SectionIcon icon="price" label="Asking Price" />
      <div style={cardStyle}>
        <StepperControl
          value={gutPriceCents > 0 ? `$${Math.round(gutPriceCents / 100).toLocaleString()}` : '\u2014'}
          onDecrement={() => onChangeGutPrice(Math.max(0, gutPriceCents - 2500))}
          onIncrement={() => onChangeGutPrice(gutPriceCents + 2500)}
          width={100}
        />
        <StepNextButton label="Run Diagnosis" disabled={gutPriceCents <= 0} onPress={onRunDiagnosis} />
      </div>
    </div>
  );
}
